import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// resources
import PreviewImage from 'assets/images/studio-preview-image-user.png'

// styles
import styles from './index.module.scss'

const SpotlightCard = ({ data }) => {
  const router = useRouter()

  const handleMerchButton = e => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}/merch`)
    }
  }

  const handleProfileButton = e => {
    if (data?.creatorUsername) {
      router.push(`/${data.creatorUsername}`)
    }
  }

  // Extract banner image, profile picture, store name, description, and products
  const storeImage = data?.creatorStoreUrl?.length > 0 ? data.creatorStoreUrl : PreviewImage.src
  const profilePicture = data?.creatorImage || ''
  const username = data?.creatorUsername || data?.username || '@username'
  const storeName = data?.storeName || data?.name || 'Store Name'
  const description =
    data?.description ||
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'

  return (
    <div className={styles.borderContainer}>
      <div className={styles.container}>
        <div className="w-full h-full">
          <ImageWithFoster src={storeImage} alt={storeName} className="w-full h-full overflow-hidden object-cover" />
        </div>
        <div className={styles.rightSection}>
          <div className="w-full">
            <div className="w-full flex gap-[8px] items-center">
              <div className="w-[65px] h-[65px] min-w-[65px] min-h-[65px] rounded-[33px] overflow-hidden">
                <ImageWithFoster src={profilePicture} className="w-full h-full rounded-[33px] overflow-hidden" />
              </div>
              <div className={styles.username} onClick={() => router.push(`/${username}`)}>
                @{username}
              </div>
            </div>
            <div className={styles.title}>{data?.name}</div>

            <div className={styles.description}>{description}</div>
          </div>
          <div className="flex gap-[15px] absolute bottom-[56px] left-[30px]">
            <div className={styles.merchButton} onClick={handleMerchButton}>
              Merch Store
            </div>
            <div className={styles.profileButton} onClick={handleProfileButton}>
              View Profile
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SpotlightCard
